import Enum from "../enums/Enum";
import EnumCountry from "../enums/EnumCountry";

const EnumInstallation = new Enum({
    DXB: {
        code: "DXB",
        name: "Dubai",
        country: EnumCountry.UAE,
        timezone: {offset: "+0400", offsetMinutes: 240, offsetHours: 4, zone: 'Asia/Dubai', code: 'GST'}
    },
    ADH: {
        code: "ADH",
        name: "Abu Dhabi",
        country: EnumCountry.UAE,
        timezone: {offset: "+0400", offsetMinutes: 240, offsetHours: 4, zone: 'Asia/Dubai', code: 'GST'}
    },
    KWT: {
        code: "KWT",
        name: "Kuwait",
        country: EnumCountry.KUWAIT,
        timezone: {offset: "+0300", offsetMinutes: 180, offsetHours: 3, zone: 'Asia/Kuwait', code: 'AST'}
    },
    RAD: {
        code: "RAD",
        name: "Diagnostics",
        country: EnumCountry.UAE,
        timezone: {offset: "+0400", offsetMinutes: 240, offsetHours: 4, zone: 'Asia/Dubai', code: 'GST'}
    },
});

export const DEFAULT_INSTALLATION = EnumInstallation.DXB;

export default EnumInstallation;